// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heart":"OrderHelpIntro-ef8c6bd6ed4b9e4a","center-text":"OrderHelpIntro-ec4c11f232db5487"};